import React from 'react';
import '@lottiefiles/lottie-player';
import './spinner.css';
import loaderAnimation from './lf20_w5segxeu.json'; 

const Loader = () => {
  return (
    <div className="spinner-wrapper">
      <div className="loader-new">
        <lottie-player
          src="https://lottie.host/a4f43b5f-adb7-4504-9552-e38c4d23dbc9/lTEHL1pE8G.json"
          background="transparent"
          speed="1"
          style={{ width: '120px', height: '120px' }}
          loop
          autoplay
        ></lottie-player>
      </div>
    </div>
  );
};

export default Loader;
